import React, { useState, useEffect } from 'react';
import { Box, Flex, Text, Button, TextField } from '@radix-ui/themes';
import { useSelector, useDispatch } from 'react-redux';
import api from '../../../api';
import { teacherAccountService } from '../../../services/teacher/accountService';
import { toast } from 'react-toastify';
import { updateTeacherDetails } from '../../../redux/slices/teacherAccountSlice';

const TeacherHandle = () => {
    const teacherAccount = useSelector(state => state.teacherAccount);

    console.log('teacherAccount', teacherAccount);

    const [newHandle, setNewHandle] = useState('');
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);

    const dispatch = useDispatch();


    const handleSubmit = async () => {
        try {
            setLoading(true);
            const data = await teacherAccountService.updateHandle(newHandle);
            toast.success('Handle updated successfully');
            const newTeacherDetails = {...teacherAccount.details, handle:data.handle}
            dispatch(updateTeacherDetails(newTeacherDetails));
            setEditing(false)
        } catch (error) {
            toast.error('Error submitting your new handle');
        } finally {
            setLoading(false);
        }
    };

    const handleGenerateUniqueHandle = async () => {
        const data = await teacherAccountService.generateUniqueHandle(teacherAccount.details.id);
        console.log(data);
        setNewHandle(data.handle);
    }

    return (
        <Flex direction="column" gap="3">
            {teacherAccount.details.handle == '' || editing == true ? (
                <>
                <Text size="2">
                    A unique handle will make it easier for students and parents to find you. Anyway who uses your handle will be able to access your profile directly.
                </Text>
                
                <TextField.Root
                    placeholder="Enter handle"
                    value={newHandle}
                    size="2"
                    onChange={(e) => setNewHandle(e.target.value)}
                />
                <Flex justify="between" gap="2">
                <Button onClick={() => handleGenerateUniqueHandle()}>Generate Unique Handle</Button>
                <Button color="green"
                onClick={handleSubmit}
                disabled={loading || !newHandle}
            >
                {loading ? 'Saving...' : 'Save Handle'}
                </Button>
                </Flex>
            
            
            </>
                
            ) : (
                <>
                    <Text size="3" color="indigo" mt="2">
                        @{teacherAccount.details.handle}
                    </Text>
                    <Text size="1">
                        You can change your handle by clicking the button below, but any existing links to your previous handle will no longer work.
                    </Text>
                    <Button variant="outline" onClick={() => {setEditing(true)}}>Change Handle</Button>
                </>
            )}
        </Flex>
    );
};

export default TeacherHandle;
